import { WHY_CHOOSE } from "@/lib/siteData";

export const WhyChooseUs = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="py-20 sm:py-28 lg:py-32 bg-green-50/40"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <span className="inline-block text-green-700 font-semibold text-sm uppercase tracking-widest">
            Why choose us
          </span>
          <h2
            data-testid="why-headline"
            className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-green-950 tracking-tight"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Friendly, local &amp; dependable.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY_CHOOSE.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={item.title}
                data-testid={`why-item-${i}`}
                className="group rounded-2xl bg-white border border-green-100 p-7 hover:border-green-300 hover:shadow-lg hover:shadow-green-900/10 transition-all"
              >
                <div className="w-12 h-12 rounded-xl bg-green-700 text-white flex items-center justify-center group-hover:scale-110 transition-transform">
                  <Icon className="w-6 h-6" />
                </div>
                <h3
                  className="mt-5 text-lg font-bold text-green-950"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
